import React from 'react';
import ProfileComponent from '../../components/ProfileComponent/ProfileComponent';

function ProfilePage() {
  return <ProfileComponent />;
}

export default ProfilePage;
